import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CommonService } from 'src/app/services/common-service/common.service';
import { ChartType, GoogleChartsModule}from 'angular-google-charts';

@Component({
  selector: 'controls-bo-linechart',
  templateUrl: './bo-linechart.component.html',
  styleUrls: ['./bo-linechart.component.scss'],
  imports:[GoogleChartsModule]
})
export class BoLinechartComponent implements OnInit {
  @Input() chartForm!: FormGroup;
  chartType = ChartType.LineChart
  columnNames = [];
  title = "";
  myData = [];
  options = { 
    hAxis: { textStyle: { fontName: 'Hellix,sans-serif', fontSize: 11.5 } },
    vAxis: { textStyle: { fontName: 'Hellix,sans-serif', fontSize: 11.5 } },
    title: '',
    legend: { position: 'bottom', textStyle: { fontName: 'Hellix,sans-serif', fontSize: 11.5 } },
    //colors: ['#0177ff', '#79b5fd', '#ff953b', '#ff3b5b'],
    colors: ['#6852c8', '#69d141', '#ff953b', '#ff3b5b'],
    chartArea: {
      bottom: 40,
      left: 30,
      right: 0,
      top: 20
    },
    lineWidth: 3,
    curveType: 'function',
  };
  cStyle: any = {};
   chartOptions = {};
    procurementOptions = {
    hAxis: {  textStyle:{ fontName:'Hellix,sans-serif', fontSize:11.5} },
    vAxis: {  textStyle:{ fontName:'Hellix,sans-serif', fontSize:11.5}},
    title: '',
    legend: { position: 'bottom', textStyle:{ fontName:'Hellix,sans-serif', fontSize:11.5} },
    colors: ['#2ecc71', '#ff4d6d'],
    pointSize: 6,
    chartArea: {
      bottom: 40,
      left: 30,
      right: 0,
      top: 20
    },
    lineWidth: 3,
    curveType: 'function'
  };

  constructor(private commonService: CommonService) { }

   ngOnInit(): void {
    if (this.chartForm.value.data) {
      this.myData = this.chartForm.value.data;
      this.commonService.ogLog('this.myData',this.myData);
      this.commonService.ogLog('this.chartForm.value',this.chartForm.value);
      this.columnNames = this.chartForm.value.columnNames;
      this.chartOptions = this.chartForm.value.isProcurementDashboard ? this.procurementOptions : this.options;
      this.cStyle = {
        width: this.chartForm.value.width,
        height: this.chartForm.value.height
      };
    }
  }

}
